import config from 'react-global-configuration';
import {configService} from './../configService';
import axios from 'axios';

export const sportsService = {
    sportsList,
    leaguesList,
    matchList,
    matchOddsList
}

function sportsList() {
    return axios
        .get(`${config.get('apiUrl')}/sports`)
        .then(configService.handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => configService.handleApiError(err));
}

function leaguesList(sportId) {
    return axios
        .get(`${config.get('apiUrl')}/leagues/${sportId}`)
        .then(configService.handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => configService.handleApiError(err));
}

function matchList(leagueId) {
    return axios
        .get(`${config.get('apiUrl')}/matches/${leagueId}`)
        .then(configService.handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => configService.handleApiError(err));
}

function matchOddsList(matchId) {
    return axios
        .get(`${config.get('apiUrl')}/matche/odds/${matchId}`)
        .then(configService.handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => configService.handleApiError(err));
}
